export type Sv3RecordType =
  | 'arrayBroDnsAnswer'
  | 'arrayBroFtpCmdarg'
  | 'arrayMatchedItem'
  | 'arrayString'
  | 'boolean'
  | 'broFtpCmdarg'
  | 'broFtpDataChannel'
  | 'broSmbCommand'
  | 'broSmbFile'
  | 'broSmbMapping'
  | 'broSmbTree'
  | 'broSmtpHeaders'
  | 'double'
  | 'float'
  | 'int'
  | 'long'
  | 'mapDouble'
  | 'mapString'
  | 'mapStringArrayString'
  | 'metadata_mapperName'
  | 'storedFile'
  | 'string'
  | 'timestamp'
  | 'unformattedInt'
  | 'uppercaseString';

interface Sv3RecordTypes {
  [name: string]: Sv3RecordType;
}

export const isMappedRecordProperty = (propName: string) =>
  recordTypes.hasOwnProperty(propName) &&
  ['mapDouble', 'mapString'].includes(recordTypes[propName]);

export const isNestedRecordProperty = (propName: string) =>
  recordTypes.hasOwnProperty(propName) &&
  [
    'broFtpCmdarg',
    'broFtpDataChannel',
    'broSmbCommand',
    'broSmbFile',
    'broSmbMapping',
    'broSmbTree',
    'broSmtpHeaders',
  ].includes(recordTypes[propName]);

export const recordTypes: Sv3RecordTypes = {
  action: 'string',
  application: 'string',
  baseImage: 'string',
  bro_dceRpc_endpoint: 'string',
  bro_dceRpc_namedPipe: 'string',
  bro_dceRpc_operation: 'string',
  bro_dceRpc_rtt: 'float',
  bro_dhcp_assignedIp_asnNumber: 'unformattedInt',
  bro_dhcp_assignedIp_asnOrg: 'string',
  bro_dhcp_assignedIp_city: 'string',
  bro_dhcp_assignedIp_countryCode: 'string',
  bro_dhcp_assignedIp_countryName: 'string',
  bro_dhcp_assignedIp_ipv4IntValue: 'long',
  bro_dhcp_assignedIp_isInternal: 'boolean',
  bro_dhcp_assignedIp_isp: 'string',
  bro_dhcp_assignedIp_latitude: 'float',
  bro_dhcp_assignedIp_location: 'string',
  bro_dhcp_assignedIp_longitude: 'float',
  bro_dhcp_assignedIp_region: 'string',
  bro_dhcp_assignedIp_version: 'int',
  bro_dhcp_assignedIp: 'string',
  bro_dhcp_leaseTime: 'double',
  bro_dhcp_mac: 'string',
  bro_dns_answers: 'arrayBroDnsAnswer',
  bro_dns_qclass: 'string',
  bro_file_bytes: 'mapString',
  bro_file_connUids: 'arrayString',
  bro_file_depth: 'int',
  bro_file_isOrigin: 'boolean',
  bro_file_localOrigin: 'boolean',
  bro_file_parentFuid: 'string',
  bro_file_source: 'string',
  bro_flow_duration: 'float',
  bro_flow_history: 'string',
  bro_flow_inIpBytes: 'long',
  bro_flow_origL2Addr: 'string',
  bro_flow_outIpBytes: 'long',
  bro_flow_respL2Addr: 'string',
  bro_flow_service: 'arrayString',
  bro_ftp_arg: 'string',
  bro_ftp_cmdarg: 'broFtpCmdarg',
  bro_ftp_command: 'string',
  bro_ftp_cwd: 'string',
  bro_ftp_dataChannel: 'broFtpDataChannel',
  bro_ftp_fileSize: 'string',
  bro_ftp_fuid: 'string',
  bro_ftp_lastAuthRequested: 'string',
  bro_ftp_mimeType: 'string',
  bro_ftp_passive: 'boolean',
  bro_ftp_password: 'string',
  bro_ftp_pendingCommands: 'arrayBroFtpCmdarg',
  bro_ftp_replyCode: 'int',
  bro_ftp_replyMsg: 'string',
  bro_http_cookieVars: 'arrayString',
  bro_http_origFuids: 'arrayString',
  bro_http_origMimeTypes: 'arrayString',
  bro_http_request_contentLength: 'int',
  bro_http_request_headers: 'mapString',
  bro_http_request_password: 'string',
  bro_http_request_proxied: 'arrayString',
  bro_http_response_headers: 'mapString',
  bro_http_response_infoCode: 'int',
  bro_http_response_infoMsg: 'string',
  bro_http_response_respFuids: 'arrayString',
  bro_http_response_respMimeTypes: 'arrayString',
  bro_http_tags: 'arrayString',
  bro_http_transDepth: 'int',
  bro_http_uriVars: 'arrayString',
  bro_irc_additionalData: 'string',
  bro_irc_command: 'string',
  bro_irc_nick: 'string',
  bro_irc_value: 'string',
  bro_kerberos_cipher: 'string',
  bro_kerberos_client: 'string',
  bro_kerberos_clientCert: 'mapString',
  bro_kerberos_errorCode: 'int',
  bro_kerberos_errorMsg: 'string',
  bro_kerberos_forwardable: 'boolean',
  bro_kerberos_from: 'float',
  bro_kerberos_renewable: 'boolean',
  bro_kerberos_requestType: 'string',
  bro_kerberos_serverCert: 'mapString',
  bro_kerberos_service: 'string',
  bro_kerberos_success: 'boolean',
  bro_kerberos_til: 'float',
  bro_ntlm_domainname: 'string',
  bro_ntlm_status: 'string',
  bro_ntlm_success: 'boolean',
  bro_protocol: 'string',
  bro_radius_connectInfo: 'string',
  bro_radius_mac: 'string',
  bro_radius_remoteIp_asnNumber: 'unformattedInt',
  bro_radius_remoteIp_asnOrg: 'string',
  bro_radius_remoteIp_city: 'string',
  bro_radius_remoteIp_countryCode: 'string',
  bro_radius_remoteIp_countryName: 'string',
  bro_radius_remoteIp_ipv4IntValue: 'long',
  bro_radius_remoteIp_isInternal: 'boolean',
  bro_radius_remoteIp_isp: 'string',
  bro_radius_remoteIp_latitude: 'float',
  bro_radius_remoteIp_location: 'string',
  bro_radius_remoteIp_longitude: 'float',
  bro_radius_remoteIp_region: 'string',
  bro_radius_remoteIp_version: 'int',
  bro_radius_remoteIp: 'string',
  bro_radius_result: 'string',
  bro_rdp_certCount: 'int',
  bro_rdp_certPermanent: 'boolean',
  bro_rdp_certType: 'string',
  bro_rdp_clientBuild: 'string',
  bro_rdp_clientDigProductId: 'string',
  bro_rdp_clientName: 'string',
  bro_rdp_cookie: 'string',
  bro_rdp_desktopHeight: 'string',
  bro_rdp_desktopWidth: 'string',
  bro_rdp_done: 'boolean',
  bro_rdp_encryptionLevel: 'string',
  bro_rdp_encryptionMethod: 'string',
  bro_rdp_keyboardLayout: 'string',
  bro_rdp_requestedColorDepth: 'string',
  bro_rdp_result: 'string',
  bro_rdp_securityProtocol: 'string',
  bro_rdp_ssl: 'boolean',
  bro_rfb_authenticationMethod: 'string',
  bro_rfb_authenticationSuccessful: 'boolean',
  bro_rfb_clientMajorVersion: 'string',
  bro_rfb_clientMinorVersion: 'string',
  bro_rfb_desktopName: 'string',
  bro_rfb_height: 'int',
  bro_rfb_serverMajorVersion: 'string',
  bro_rfb_serverMinorVersion: 'string',
  bro_rfb_sharedSession: 'boolean',
  bro_rfb_width: 'int',
  bro_sip_headers: 'mapString',
  bro_sip_requestBodyLength: 'int',
  bro_sip_requestFrom: 'string',
  bro_sip_requestMethod: 'string',
  bro_sip_requestPath: 'arrayString',
  bro_sip_requestTo: 'string',
  bro_sip_requestUri: 'string',
  bro_sip_responseBodyLength: 'int',
  bro_sip_responseFrom: 'string',
  bro_sip_responsePath: 'arrayString',
  bro_sip_responseTo: 'string',
  bro_sip_statusCode: 'int',
  bro_sip_statusMsg: 'string',
  bro_smb_command: 'broSmbCommand',
  bro_smb_file: 'broSmbFile',
  bro_smb_mapping: 'broSmbMapping',
  bro_smb_tree: 'broSmbTree',
  bro_smtp_headers: 'broSmtpHeaders',
  bro_smtp_isWebmail: 'boolean',
  bro_smtp_lastReply: 'string',
  bro_smtp_path: 'string',
  bro_smtp_tls: 'boolean',
  bro_smtp_transDepth: 'int',
  bro_smtp_userAgent: 'string',
  bro_snmp_community: 'string',
  bro_snmp_displayString: 'string',
  bro_snmp_duration: 'double',
  bro_snmp_getBulkRequests: 'int',
  bro_snmp_getRequests: 'int',
  bro_snmp_getResponses: 'int',
  bro_snmp_setRequests: 'int',
  bro_snmp_upSince: 'long',
  bro_snmp_version: 'string',
  bro_socks_boundIp_asnNumber: 'unformattedInt',
  bro_socks_boundIp_asnOrg: 'string',
  bro_socks_boundIp_city: 'string',
  bro_socks_boundIp_countryCode: 'string',
  bro_socks_boundIp_countryName: 'string',
  bro_socks_boundIp_ipv4IntValue: 'long',
  bro_socks_boundIp_isInternal: 'boolean',
  bro_socks_boundIp_isp: 'string',
  bro_socks_boundIp_latitude: 'float',
  bro_socks_boundIp_location: 'string',
  bro_socks_boundIp_longitude: 'float',
  bro_socks_boundIp_region: 'string',
  bro_socks_boundIp_version: 'int',
  bro_socks_boundIp: 'string',
  bro_socks_boundName: 'string',
  bro_socks_boundPort: 'unformattedInt',
  bro_socks_password: 'string',
  bro_socks_requestIp_asnNumber: 'unformattedInt',
  bro_socks_requestIp_asnOrg: 'string',
  bro_socks_requestIp_city: 'string',
  bro_socks_requestIp_countryCode: 'string',
  bro_socks_requestIp_countryName: 'string',
  bro_socks_requestIp_ipv4IntValue: 'long',
  bro_socks_requestIp_isInternal: 'boolean',
  bro_socks_requestIp_isp: 'string',
  bro_socks_requestIp_latitude: 'float',
  bro_socks_requestIp_location: 'string',
  bro_socks_requestIp_longitude: 'float',
  bro_socks_requestIp_region: 'string',
  bro_socks_requestIp_version: 'int',
  bro_socks_requestIp: 'string',
  bro_socks_requestName: 'string',
  bro_socks_requestPort: 'unformattedInt',
  bro_socks_status: 'string',
  bro_socks_version: 'int',
  bro_ssh_authSuccess: 'boolean',
  bro_ssh_cipherAlgorithm: 'string',
  bro_ssh_client: 'string',
  bro_ssh_compressionAlgorithm: 'string',
  bro_ssh_hostKeyAlgorithm: 'string',
  bro_ssh_keyExchangeAlgorithm: 'string',
  bro_ssh_macAlgorithm: 'string',
  bro_ssh_server: 'string',
  bro_ssh_version: 'int',
  bro_ssl_certChainFuids: 'arrayString',
  bro_ssl_cipher: 'string',
  bro_ssl_clientCertChainFuids: 'arrayString',
  bro_ssl_curve: 'string',
  bro_ssl_established: 'boolean',
  bro_ssl_issuer: 'string',
  bro_ssl_nextProtocol: 'string',
  bro_ssl_resumed: 'boolean',
  bro_ssl_serverName_alexaRank: 'long',
  bro_ssl_serverName_conditionalFrequency: 'double',
  bro_ssl_serverName_entropyFqdn: 'double',
  bro_ssl_serverName_entropyRootDomain: 'double',
  bro_ssl_serverName_entropySubDomain: 'double',
  bro_ssl_serverName_fqdn: 'string',
  bro_ssl_serverName_possibleDga: 'boolean',
  bro_ssl_serverName_possibleDynDns: 'boolean',
  bro_ssl_serverName_rootDomain: 'string',
  bro_ssl_serverName_tld: 'string',
  bro_ssl_serverName: 'string',
  bro_ssl_subject: 'string',
  bro_ssl_version: 'string',
  bytesIn: 'long',
  bytesOut: 'long',
  changeTarget: 'string',
  changeType: 'string',
  commandLine: 'string',
  cseSignal: 'mapString',
  day: 'int',
  description: 'string',
  device_hostname: 'string',
  device_ip_asnNumber: 'unformattedInt',
  device_ip_asnOrg: 'string',
  device_ip_city: 'string',
  device_ip_countryCode: 'string',
  device_ip_countryName: 'string',
  device_ip_ipv4IntValue: 'long',
  device_ip_isInternal: 'boolean',
  device_ip_isp: 'string',
  device_ip_latitude: 'float',
  device_ip_location: 'string',
  device_ip_longitude: 'float',
  device_ip_region: 'string',
  device_ip_version: 'int',
  device_ip: 'string',
  device_mac: 'string',
  device_natIp_asnNumber: 'unformattedInt',
  device_natIp_asnOrg: 'string',
  device_natIp_city: 'string',
  device_natIp_countryCode: 'string',
  device_natIp_countryName: 'string',
  device_natIp_ipv4IntValue: 'long',
  device_natIp_isInternal: 'boolean',
  device_natIp_isp: 'string',
  device_natIp_latitude: 'float',
  device_natIp_location: 'string',
  device_natIp_longitude: 'float',
  device_natIp_region: 'string',
  device_natIp_version: 'int',
  device_natIp: 'string',
  device_uniqueId: 'string',
  dns_query: 'string',
  dns_queryDomain_alexaRank: 'long',
  dns_queryDomain_conditionalFrequency: 'double',
  dns_queryDomain_entropyFqdn: 'double',
  dns_queryDomain_entropyRootDomain: 'double',
  dns_queryDomain_entropySubDomain: 'double',
  dns_queryDomain_fqdn: 'string',
  dns_queryDomain_possibleDga: 'boolean',
  dns_queryDomain_possibleDynDns: 'boolean',
  dns_queryDomain_rootDomain: 'string',
  dns_queryDomain_tld: 'string',
  dns_queryDomain: 'string',
  dns_queryType: 'string',
  dns_reply: 'string',
  dns_replyDomain_alexaRank: 'long',
  dns_replyDomain_conditionalFrequency: 'double',
  dns_replyDomain_entropyFqdn: 'double',
  dns_replyDomain_entropyRootDomain: 'double',
  dns_replyDomain_entropySubDomain: 'double',
  dns_replyDomain_fqdn: 'string',
  dns_replyDomain_possibleDga: 'boolean',
  dns_replyDomain_possibleDynDns: 'boolean',
  dns_replyDomain_rootDomain: 'string',
  dns_replyDomain_tld: 'string',
  dns_replyDomain: 'string',
  dns_replyIp_asnNumber: 'unformattedInt',
  dns_replyIp_asnOrg: 'string',
  dns_replyIp_city: 'string',
  dns_replyIp_countryCode: 'string',
  dns_replyIp_countryName: 'string',
  dns_replyIp_ipv4IntValue: 'long',
  dns_replyIp_isInternal: 'boolean',
  dns_replyIp_isp: 'string',
  dns_replyIp_latitude: 'float',
  dns_replyIp_location: 'string',
  dns_replyIp_longitude: 'float',
  dns_replyIp_region: 'string',
  dns_replyIp_version: 'int',
  dns_replyIp: 'string',
  dns_returnCode: 'string',
  dstDevice_hostname: 'string',
  dstDevice_ip_asnNumber: 'unformattedInt',
  dstDevice_ip_asnOrg: 'string',
  dstDevice_ip_city: 'string',
  dstDevice_ip_countryCode: 'string',
  dstDevice_ip_countryName: 'string',
  dstDevice_ip_ipv4IntValue: 'long',
  dstDevice_ip_isInternal: 'boolean',
  dstDevice_ip_isp: 'string',
  dstDevice_ip_latitude: 'float',
  dstDevice_ip_location: 'string',
  dstDevice_ip_longitude: 'float',
  dstDevice_ip_region: 'string',
  dstDevice_ip_version: 'int',
  dstDevice_ip: 'string',
  dstDevice_mac: 'string',
  dstDevice_natIp_asnNumber: 'unformattedInt',
  dstDevice_natIp_asnOrg: 'string',
  dstDevice_natIp_city: 'string',
  dstDevice_natIp_countryCode: 'string',
  dstDevice_natIp_countryName: 'string',
  dstDevice_natIp_ipv4IntValue: 'long',
  dstDevice_natIp_isInternal: 'boolean',
  dstDevice_natIp_isp: 'string',
  dstDevice_natIp_latitude: 'float',
  dstDevice_natIp_location: 'string',
  dstDevice_natIp_longitude: 'float',
  dstDevice_natIp_region: 'string',
  dstDevice_natIp_version: 'int',
  dstDevice_natIp: 'string',
  dstDevice_uniqueId: 'string',
  dstPort: 'unformattedInt',
  email_messageId: 'string',
  email_sender: 'string',
  email_subject: 'string',
  fields: 'mapString',
  fieldTags: 'mapStringArrayString',
  file_basename: 'string',
  file_hash_imphash: 'string',
  file_hash_md5: 'string',
  file_hash_pehash: 'string',
  file_hash_sha1: 'string',
  file_hash_sha256: 'string',
  file_hash_ssdeep: 'string',
  file_mimeType: 'string',
  file_path: 'string',
  file_size: 'long',
  file_uid: 'string',
  flowState: 'string',
  friendlyName: 'string',
  fromUser_authDomain: 'string',
  fromUser_email: 'string',
  fromUser_userId: 'string',
  fromUser_username: 'string',
  hour: 'int',
  http_hostname: 'string',
  http_method: 'string',
  http_referer_alexaRank: 'long',
  http_referer_conditionalFrequency: 'double',
  http_referer_entropyFqdn: 'double',
  http_referer_entropyRootDomain: 'double',
  http_referer_entropySubDomain: 'double',
  http_referer_fqdn: 'string',
  http_referer_path: 'string',
  http_referer_possibleDga: 'boolean',
  http_referer_possibleDynDns: 'boolean',
  http_referer_protocol: 'string',
  http_referer_rootDomain: 'string',
  http_referer_tld: 'string',
  http_referer: 'string',
  http_requestHeaders: 'mapString',
  http_response_contentLength: 'int',
  http_response_contentType: 'string',
  http_response_statusCode: 'int',
  http_response_statusText: 'string',
  http_url_alexaRank: 'long',
  http_url_conditionalFrequency: 'double',
  http_url_entropyFqdn: 'double',
  http_url_entropyRootDomain: 'double',
  http_url_entropySubDomain: 'double',
  http_url_fqdn: 'string',
  http_url_path: 'string',
  http_url_possibleDga: 'boolean',
  http_url_possibleDynDns: 'boolean',
  http_url_protocol: 'string',
  http_url_rootDomain: 'string',
  http_url_tld: 'string',
  http_url: 'string',
  http_userAgent: 'string',
  ipProtocol: 'uppercaseString',
  listMatches: 'arrayString',
  logonType: 'string',
  matchedItems: 'arrayMatchedItem',
  metadata_defaultTz: 'int',
  metadata_deviceEventId: 'string',
  metadata_mapperName: 'metadata_mapperName',
  metadata_parseTime: 'timestamp',
  metadata_product: 'string',
  metadata_productGuid: 'string',
  metadata_receiptTime: 'timestamp',
  metadata_relayHostname: 'string',
  metadata_relayIp: 'string',
  metadata_schemaVersion: 'int',
  metadata_sensorId: 'string',
  metadata_sensorInformation: 'mapString',
  metadata_sensorZone: 'string',
  metadata_tenantId: 'string',
  metadata_vendor: 'string',
  moduleType: 'string',
  month: 'int',
  normalized_severity_description: 'string',
  normalized_severity: 'int',
  objectType: 'string',
  packetsIn: 'long',
  packetsOut: 'long',
  parentPid: 'unformattedInt',
  pid: 'unformattedInt',
  processUid: 'string',
  resource: 'string',
  severity: 'string',
  storedFilePath: 'storedFile',
  'fields.storedFilePath': 'storedFile',
  sourceUid: 'string',
  srcDevice_hostname: 'string',
  srcDevice_ip_asnNumber: 'unformattedInt',
  srcDevice_ip_asnOrg: 'string',
  srcDevice_ip_city: 'string',
  srcDevice_ip_countryCode: 'string',
  srcDevice_ip_countryName: 'string',
  srcDevice_ip_ipv4IntValue: 'long',
  srcDevice_ip_isInternal: 'boolean',
  srcDevice_ip_isp: 'string',
  srcDevice_ip_latitude: 'float',
  srcDevice_ip_location: 'string',
  srcDevice_ip_longitude: 'float',
  srcDevice_ip_region: 'string',
  srcDevice_ip_version: 'int',
  srcDevice_ip: 'string',
  srcDevice_mac: 'string',
  srcDevice_natIp_asnNumber: 'unformattedInt',
  srcDevice_natIp_asnOrg: 'string',
  srcDevice_natIp_city: 'string',
  srcDevice_natIp_countryCode: 'string',
  srcDevice_natIp_countryName: 'string',
  srcDevice_natIp_ipv4IntValue: 'long',
  srcDevice_natIp_isInternal: 'boolean',
  srcDevice_natIp_isp: 'string',
  srcDevice_natIp_latitude: 'float',
  srcDevice_natIp_location: 'string',
  srcDevice_natIp_longitude: 'float',
  srcDevice_natIp_region: 'string',
  srcDevice_natIp_version: 'int',
  srcDevice_natIp: 'string',
  srcDevice_uniqueId: 'string',
  srcPort: 'unformattedInt',
  success: 'boolean',
  tcpProtocol: 'uppercaseString',
  threat_identifier: 'string',
  threat_name: 'string',
  threat_referenceUrl: 'string',
  timestamp: 'timestamp',
  uid: 'string',
  user_authDomain: 'string',
  user_email: 'string',
  user_userId: 'string',
  user_username: 'string',
  vuln_bugtraq: 'string',
  vuln_cert: 'string',
  vuln_cve: 'string',
  vuln_cvss: 'string',
  vuln_name: 'string',
  vuln_reference: 'string',
  year: 'unformattedInt',
};
